exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".app-region li[data-v-3c989efb]{display:inline-block}.app-region-item[data-v-3c989efb]{display:inline-block;width:150px}", "", {"version":3,"sources":["/home/work/jenkins/workspace/FD-FE_hfsfd-student/src/views/index/components/AppSelectArea.vue"],"names":[],"mappings":"AAGA,gCACE,oBAAsB,CACvB,AACD,kCACE,qBAAsB,AACtB,WAAa,CACd","file":"AppSelectArea.vue","sourcesContent":["\n@charset \"UTF-8\";\n/*颜色库*/\n.app-region li[data-v-3c989efb] {\n  display: inline-block;\n}\n.app-region-item[data-v-3c989efb] {\n  display: inline-block;\n  width: 150px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-3c989efb","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/home/work/jenkins/workspace/FD-FE_hfsfd-student/src/assets/styles/base/colorLibrary.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/index/components/AppSelectArea.vue
// module id = w3mZ
// module chunks = 13